const NavbarPlaceholder = () => {
    return null;

    return (
        <img
            width='100%'
            height='auto'
            style={{
                width: '100%',
                margin: 0,
                padding: 0,
                filter: 'drop-shadow(0px 1px 4px #222222)',
                zIndex: 100,
            }}
            src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/Navbar.png'
            alt='Navbar'
        />
    );
};

export default NavbarPlaceholder;
